import { Link } from 'react-router-dom';

const SERVICES = [
  {
    icon: 'ri-search-eye-line',
    title: '集客コンサルティング',
    desc: 'SEO対策・広告運用・LP改善など、Web集客を中心とした安定した見込み顧客獲得の仕組みを構築します。',
    features: ['SEO対策・コンテンツ戦略', 'リスティング・SNS広告運用', 'LP改善・問い合わせ導線最適化'],
    anchor: '#attraction',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: '営業支援コンサルティング',
    desc: '営業プロセスの設計から再現性のある営業体制の構築まで、成約率向上を一貫して支援します。',
    features: ['営業プロセス設計・改善', 'トークスクリプト・提案資料整備', '成約率向上フロー構築'],
    anchor: '#sales',
  },
  {
    icon: 'ri-refresh-line',
    title: '継続改善支援',
    desc: 'KPI設計・数値分析・月次レポートにより、中長期的な事業成長を継続的にサポートします。',
    features: ['KPI設計・数値分析', '月次レポート・改善提案', '中長期的な運用支援'],
    anchor: '#improvement',
  },
];

export default function ServicesSection() {
  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div>
            <span className="text-xs font-semibold tracking-[3px] text-gray-400 uppercase">Services</span>
            <h2 className="text-3xl md:text-5xl font-bold text-[#1a2332] mt-3">提供サービス</h2>
          </div>
          <p className="text-base text-gray-500 max-w-sm leading-relaxed">
            集客から営業まで一気通貫で支援。<br />
            安定した売上基盤の構築をサポートします。
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((svc) => (
            <div
              key={svc.title}
              className="group bg-[#faf9f7] rounded-2xl p-8 md:p-10 hover:bg-[#1a2332] transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#1a2332] group-hover:bg-white/20 mb-8 transition-colors duration-300">
                <i className={`${svc.icon} text-2xl text-white`} />
              </div>
              <h3 className="text-xl font-bold text-[#1a2332] group-hover:text-white mb-4 transition-colors duration-300">
                {svc.title}
              </h3>
              <p className="text-sm text-gray-500 group-hover:text-white/70 leading-relaxed mb-6 transition-colors duration-300">
                {svc.desc}
              </p>
              <ul className="space-y-2 mb-8">
                {svc.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-gray-600 group-hover:text-white/80 transition-colors duration-300">
                    <i className="ri-check-line text-[#1a2332] group-hover:text-white/60 transition-colors duration-300" />
                    {f}
                  </li>
                ))}
              </ul>
              <Link
                to={`/services${svc.anchor}`}
                className="inline-flex items-center gap-2 text-sm font-medium text-[#1a2332] group-hover:text-white transition-colors duration-300 whitespace-nowrap"
                onClick={(e) => e.stopPropagation()}
              >
                詳しく見る <i className="ri-arrow-right-line" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
